import {connect} from 'react-redux';
import {search, fetchPosts} from './../../actions';
import React, {Component} from 'react';
import Search from '../../components/partial/Search/Search';

class SearchController extends Component {

  render() {
    return (
      <Search {...this.props}/>
    );
  }
}

function mapStateToProps(state) {
  return {
    filter: state.search.filter,
    tag: state.posts.tag,
    locale: state.locale.data
  };
}

function mapDispatchToProps(dispatch) {
  return {
    search(params) {
      dispatch(search(params));
    },
    fetchPosts(params) {
      dispatch(fetchPosts(params));
    }
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(SearchController);



// WEBPACK FOOTER //
// ./containers/Search/Search.js